import { differenceInMinutes, differenceInHours, differenceInDays, format } from 'date-fns';

export function getRelativeTime(dateInput, isOnline) {
  if (isOnline) return 'Active now';

  const utcDate = new Date(typeof dateInput === 'string' ? (dateInput.endsWith('Z') ? dateInput : dateInput + 'Z') : dateInput);

  const now = new Date();
  const diffMins = differenceInMinutes(now, utcDate);
  const diffHours = differenceInHours(now, utcDate);
  const diffDays = differenceInDays(now, utcDate);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays <= 7) return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;

  return format(utcDate, 'dd MMM yyyy');
}
